import React, { Fragment, useEffect, useState } from "react";
import { Link } from "react-router-dom";

// import material UI
import { makeStyles } from "@material-ui/core/styles";
import { DataGrid, RowsProp, ColDef } from "@material-ui/data-grid";
import { Paper } from "@material-ui/core";
import { Edit as EditIcon, Delete as DeleteIcon } from "@material-ui/icons";

import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";

// import action
import { getAllkyc, approverejectkyc } from "../../actions/airdrop";

// import
import { toastAlert } from "../../lib/toastAlert";
import { useParams } from "react-router-dom";
import config from "../../lib/config";

const styles = {
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0",
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF",
    },
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1",
    },
  },
  flexHeader: {
    display: "flex !important",
    justifyContent: "space-between !important",
    alignItems: "center !important",
  },
  btnPrimary: {
    backgroundColor: "#b462c5",
    color: "#ffffff !important",
    padding: "7px 15px",
    fontSize: "12px",
    fontWeight: "700",
  },
};
const useStyles = makeStyles(styles);

const ReferralList = (props) => {
  const classes = useStyles();
  const params = useParams();
  // state
  const [data, setData] = useState([]);

  const columns = [
    { field: "Address", headerName: "Address", width: 400 },
    { field: "name", headerName: "Name", width: 200 },

    { field: "status", headerName: "Kyc Status", width: 200 },

    {
      field: "Type",
      headerName: "Type",
      width: 200,
      renderCell: (params) => {
        return <Fragment>{params.row?.idProof?.type}</Fragment>;
      },
    },

    {
      field: "Id Proof front",
      headerName: "Id Proof Front",
      width: 200,
      renderCell: (params) => {
        return (
          <span>
            <a
              href={
                config.baseUrl +
                "/images/kyc/" +
                params.row?.idProof?.frontImage
              }
            >
              {params.row?.idProof?.frontImage}
            </a>
          </span>
        );
      },
    },

    {
      field: "Id Proof back",
      headerName: "Id Proof Back",
      width: 200,
      renderCell: (params) => {
        return (
          <span>
            <a
              href={
                config.baseUrl + "/images/kyc/" + params.row?.idProof?.backImage
              }
            >
              {params.row?.idProof?.backImage}
            </a>
          </span>
        );
      },
    },

    {
      field: "Address Proof ",
      headerName: "Address Proof",
      width: 200,
      renderCell: (params) => {
        return (
          <span>
            <a
              href={
                config.baseUrl +
                "/images/kyc/" +
                params.row?.addressProof?.frontImage
              }
            >
              {params.row?.idProof?.backImage}
            </a>
          </span>
        );
      },
    },

    {
      field: "Selfie Proof ",
      headerName: "Selfie Proof",
      width: 200,
      renderCell: (params) => {
        return (
          <span>
            <a
              href={
                config.baseUrl +
                "/images/kyc/" +
                params.row?.selfiId?.frontImage
              }
            >
              {params.row?.idProof?.backImage}
            </a>
          </span>
        );
      },
    },

    { field: "createdAt", headerName: "Created At", width: 200 },

    {
      field: "Action",
      headerName: "Action",
      width: 200,
      renderCell: (params) => {
        return (
          <span>
            {params.row.status == "rejected" ||
              (params.row.status == "pending" && (
                <button
                  onClick={(e) => approvereject("approve", params.row._id)}
                  className={classes.btnPrimary}
                >
                  Approve
                </button>
              ))}{" "}
            {params.row.status != "rejected" && (
              <button
                onClick={(e) => approvereject("reject", params.row._id)}
                className={classes.btnPrimary}
              >
                Reject
              </button>
            )}
          </span>
        );
      },
    },
  ];

  // function
  const fetchhistory = async () => {
    try {
      const { status, loading, error, result } = await getAllkyc();
      if (status == "success") {
        // console.log(result, 'result')
        let respData = result.data.map((item, key) => {
          // console.log(item, 'itemmmmmmmmmmmmmmm')
          return {
            id: key,
            ...item,
          };
        });
        // console.log(respData, 'resssssssssss')
        setData(respData);
      } else {
      }
    } catch (err) {
      console.log(err, "errror");
    }
  };

  useEffect(() => {
    setTimeout(() => {
      fetchhistory();
    }, 500);
  }, []);

  // console.log(data, 'datadata')

  const approvereject = async (type, mainid) => {
    if (window.confirm("Are you sure want to " + type + " KYC") == true) {
      var res = await approverejectkyc({ type: type, mainid: mainid });
      // console.log(res, "----747474");
      toastAlert("success", res.message, "address");
      fetchhistory();
      // console.log(id, "idddd------", mainid, "-mainid----");
    }
  };

  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <Card>
          <CardHeader color="primary">
            <div className={classes.flexHeader}>
              <h4 className={classes.cardTitleWhite}>Kyc List</h4>
            </div>
          </CardHeader>
          <CardBody>
            <div style={{ height: 600, width: "100%" }}>
              <DataGrid
                pageSize={10}
                pagination
                rows={data}
                columns={columns}
              />
            </div>
          </CardBody>
        </Card>
      </Paper>
    </div>
  );
};

export default ReferralList;
